export default __webpack_public_path__ + "static/media/portfolio2.225acae1.jpg";